export default {
  storeCacheMs: 60000,
};
